import contratacoesRotas from './contratacoes/ContratacoesRotas'
import entregasRotas from './entregas/EntregasRotas'
import paineisRotas from './paineis/PaineisRotas'
import solicitacoesAditivosRotas from './solicitacoesaditivos/SolicitacoesAditivosRotas'
import solicitacoesReaberturasRotas from './solicitacoesreaberturas/SolicitacoesReaberturasRotas'

export default {
    path: 'gestores',
    name: 'Gestores',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        contratacoesRotas,
        entregasRotas,
        paineisRotas,
        solicitacoesAditivosRotas,
        solicitacoesReaberturasRotas
    ]
}
